import React, { Fragment, useEffect, useState } from 'react';
import { useParams, Link } from "react-router-dom";
import { Btn, H3, H4, P, Image } from "../../../AbstractElements";
import { useForm } from 'react-hook-form';
import { Row, Col, Container, Card, CardHeader, CardBody, CardFooter, Form, FormGroup, Label, Input, Toast } from 'reactstrap'
import TableBuilder, { RegisteredInputsBuilder, ApiRequestBuilder, ToastBuilder, ModalButtonBuilder, FormOptionsBuilder } from '../../../GlobalComponents/Builders';
import { buildOptionsFromArray, loadObjectToTextArea, parseJSONSafe, renameKeysCamelToSnake, setInitialFormValues } from '../../../GlobalComponents/Helpers';
import { ContentLoader } from '../../../Layout/Loader';

document.title = 'View Service'

const ServiceResources = () => {

    let { serviceId } = useParams();

    const [isProcessing, setIsProcessing] = useState(true);
    const [serviceData, setServiceData] = useState('');
    const [partnerData, setPartnerData] = useState([]);
    const [resourceData, setResourceData] = useState([]);
    const [resourceKeyData, setResourceKeyData] = useState([]);
    const [newResourceIsSetup, setNewResourceIsSetup] = useState(false);
    const { register, handleSubmit, setValue, formState: { errors, isValid }, watch, control } = useForm();

    const getServiceData = () => {

        ApiRequestBuilder('servicesServiceIdResourcesGet', { serviceId }, null, { setIsProcessing }).then(function (results) {
            setServiceData(results.data[0].name)
            setResourceData(results.data[0].resources)
        })
    }

    const getPartnerData = () => {
        ApiRequestBuilder('partnersGet', null, null, null, {fields: 'id,name'}).then(function (results) {
            setPartnerData(results.data)
        })
    }



    const getResourceKeys = (resourceId) => {
        ApiRequestBuilder('servicesServiceIdResourcesResourceIdKeysGet', { serviceId, resourceId }).then(function (results) {
            if (results.data.length > 0) {
                setResourceKeyData(results.data[0].keys)
            } else {
                setResourceKeyData([])
            }
        })
    }

    const handleServiceResourceUpdate = (data, resourceId) => {

        function containsNumber(str, num) {
            const regex = new RegExp(`[a-zA-Z]+${num}$`);
            return regex.test(str);
        }

        var cleanFormData = {};

        for (const key in data) {
            if (containsNumber(key, resourceId)
                // && !key.includes('jobId')
                && !key.includes('partnerId')
                && !key.includes('parentResource')
            ) {
                cleanFormData[key.replace(resourceId, '')] = data[key]
            }
        }
        cleanFormData.resourceOptions = parseJSONSafe(cleanFormData.resourceOptions)

        // Query Handler
        ApiRequestBuilder('servicesServiceIdResourcesResourceIdPatch', { serviceId, resourceId }, renameKeysCamelToSnake(cleanFormData), {toastOnSuccess: 'Resource Updated Successfully'})
        .then(function (results) {
            console.log(results)
            getServiceData()
        })
    }

    const handleResourceCreate = (update) => {

        let parentResourceId = update['parentResourceIdNew'] ? update['parentResourceIdNew'] : null

        ApiRequestBuilder('servicesServiceIdResourcesPost', { serviceId }, {
            resourceName: update['resourceNameNew'],
            resource: update['resourceNew'],
            parentResourceId: parentResourceId,
            isSetupResource: parseInt(update['isSetupResourceNew']),
            resourceOptions: newResourceIsSetup ? parseJSONSafe(update['setupResourceArgsNew']) : null,
        },{toastOnSuccess: 'Resource Created Successfully'}).then(function (results) {
            getServiceData()
        })
    }

    useEffect(() => {

        getPartnerData()

        getServiceData()

    }, []);

    return (
        <Fragment>
            <ContentLoader isLoading={isProcessing} />
            <Row>
                <Container>
                    <Card>
                        <CardBody>
                            <TableBuilder
                                subHeader={true}
                                columnsToSearch={['name', 'resource', 'table_reference']}
                                data={resourceData}
                                processing={false}
                                pagination={false}
                                title={serviceData + ' Resources'}
                                actions={<ModalButtonBuilder title='Create Resource' className='btn-primary' size='md' formIsValid={isValid} formErrors={errors}
                                    body={
                                        <Form id='create-resource-form'
                                            onSubmit={handleSubmit(handleResourceCreate)}
                                        >
                                            <RegisteredInputsBuilder
                                                registrator={register}
                                                registratorErrors={errors}
                                                control={control}
                                                inputs={[
                                                    {
                                                        label: 'Name',
                                                        size: 11,
                                                        required: true,
                                                        name: 'resourceNameNew'
                                                    },
                                                    {
                                                        label: 'Resource',
                                                        size: 11,
                                                        required: !newResourceIsSetup,
                                                        name: 'resourceNew',
                                                        helpText: 'API endpoint or resource identifier'
                                                    },
                                                    {
                                                        label: 'Parent Resource',
                                                        type: 'reactselect',
                                                        size: 11,
                                                        required: false,
                                                        name: 'parentResourceIdNew',
                                                        options: buildOptionsFromArray([{ name: '', resource_id: null }].concat(resourceData), { label: 'name', value: 'resource_id' }),
                                                    },
                                                    {
                                                        label: 'Is Setup',
                                                        type: 'select',
                                                        size: 11,
                                                        inputSize: 3,
                                                        options: <FormOptionsBuilder options={buildOptionsFromArray([{ id: 0, value: 'No' }, { id: 1, value: 'Yes' }], { label: 'value', value: 'id' })} />,
                                                        name: 'isSetupResourceNew',
                                                        onChange: (e) => {
                                                            setNewResourceIsSetup(parseInt(e.target.value) === 1 ? true : false)
                                                        },
                                                    },
                                                    {
                                                        label: 'Setup Args',
                                                        type: 'textarea',
                                                        visible: newResourceIsSetup,
                                                        size: 11,
                                                        required: false,
                                                        name: 'setupResourceArgsNew',
                                                        settings: { handleTabs: true, resize: true },
                                                    }
                                                ]} />
                                        </Form>
                                    }
                                />}
                                columns={[
                                    {
                                        name: 'ID',
                                        selector: (row) => row.resource_id,
                                        sortable: true,
                                        center: true,
                                        maxWidth: '5%'
                                    },
                                    {
                                        name: 'Name',
                                        selector: (row) => row.name,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Resource',
                                        selector: (row) => row.resource,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Parent URL',
                                        selector: (row) => {
                                            if (row.parent_resource_id === null) {
                                                return '-'
                                            }

                                            const parentResourceName = resourceData.find(resource => resource.resource_id === row.parent_resource_id)?.name;
                                            const parentResourceUrl = resourceData.find(resource => resource.resource_id === row.parent_resource_id)?.resource;
                                            const useParentResourceUrl = parseInt(row.use_parent_url) === 1 ? true : false;

                                            if (parentResourceName && useParentResourceUrl) {
                                                return <p style={{ fontSize: 'small', textDecoration: 'underline' }} title={`${parentResourceUrl}/XXX/${row.resource}`}>{`${parentResourceName} (ID: ${row.parent_resource_id})`}</p>
                                            }

                                            return `${parentResourceName} (ID: ${row.parent_resource_id})`;
                                        },
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Custom',
                                        selector: (row) => {
                                            if (!row.partner_id && !row.job_id) return '-';
                                            let titleText = '';
                                            if (row.job_id) {
                                                titleText += `Job ID: ${row.job_id}\n`;
                                            }
                                            if (row.partner_id) {
                                                const partner = partnerData.find(p => p.id === row.partner_id);
                                                const partnerName = partner ? partner.name : '';
                                                titleText += `Partner ID: ${row.partner_id}${partnerName ? `\nPartner Name: ${partnerName}` : ''}\n`;
                                            }
                                            return <span title={`${titleText}`}>Custom</span>
                                        },
                                        sortable: true,
                                        center: true,
                                        maxWidth: '10%',
                                    },
                                    {
                                        name: 'Table',
                                        selector: (row) => row.table_reference,
                                        sortable: true,
                                        center: true,
                                    },
                                    {
                                        name: 'Manage',
                                        center: true,
                                        maxWidth: '13%',
                                        selector: (row) =>
                                            <ModalButtonBuilder title='View / Edit' className='btn-secondary m-1' style={{ minWidth: 500 }}
                                                onClick={() => {
                                                    getResourceKeys(row.resource_id);
                                                    row.resource_options = loadObjectToTextArea(row.resource_options)
                                                    if (row.partner_id && partnerData.length > 0) {
                                                        console.log(partnerData)
                                                        const partner = partnerData.find(p => p.id === row.partner_id);
                                                        row.partner_id = partner ? partner.name : row.partner_id;
                                                    }
                                                    if (row.parent_resource_id === null) {
                                                        row.parent_resource_id = 0;
                                                    }
                                                    setInitialFormValues(row, setValue, 'resource_id')
                                                }}
                                                formId={'view-/-edit-form' + row.resource_id}
                                                body={
                                                    <Form id={'view-/-edit-form' + row.resource_id} onSubmit={handleSubmit(data => handleServiceResourceUpdate(data, row.resource_id))}>
                                                        <RegisteredInputsBuilder
                                                            registrator={register}
                                                            registratorErrors={errors}
                                                            control={control}
                                                            inputs={[
                                                                {
                                                                    label: 'Name',
                                                                    size: 11,
                                                                    name: 'name' + row.resource_id
                                                                },
                                                                {
                                                                    label: 'Resource',
                                                                    size: 11,
                                                                    name: 'resource' + row.resource_id
                                                                },
                                                                {
                                                                    label: 'Parent Resource',
                                                                    name: 'parentResourceId' + row.resource_id,
                                                                    type: 'reactselect',
                                                                    size: 11,
                                                                    required: false,
                                                                    options: (() => {
                                                                        const nullOption = { name: 'None', resource_id: 0 };
                                                                        if (row.parent_resource_id && resourceData.length > 0) {
                                                                            const parent = resourceData.find(r => parseInt(r.resource_id) === parseInt(row.parent_resource_id));
                                                                            const others = resourceData.filter(r => parseInt(r.resource_id) !== parseInt(row.parent_resource_id));
                                                                            return buildOptionsFromArray(parent ? [parent, ...others] : [nullOption, ...resourceData], { label: 'name', value: 'resource_id' });
                                                                        }
                                                                        return buildOptionsFromArray([nullOption, ...resourceData], { label: 'name', value: 'resource_id' });
                                                                    })()
                                                                },
                                                                {
                                                                    label: 'Parent URL',
                                                                    type: 'reactselect',
                                                                    size: 11,
                                                                    name: 'useParentUrl' + row.resource_id,
                                                                    options: buildOptionsFromArray([{ id: 0, value: 'No' }, { id: 1, value: 'Yes' }], { label: 'value', value: 'id' }),
                                                                },
                                                                {
                                                                    label: 'Resource Args',
                                                                    type: 'textarea',
                                                                    size: 11,
                                                                    required: false,
                                                                    settings: { handleTabs: true, resize: true },
                                                                    name: 'resourceOptions' + row.resource_id
                                                                },
                                                                {
                                                                    label: 'Table',
                                                                    size: 11,
                                                                    name: 'tableReference' + row.resource_id
                                                                },
                                                                {
                                                                    label: 'Partner',
                                                                    type: 'static',
                                                                    size: 11,
                                                                    required: false,
                                                                    name: 'partnerId' + row.resource_id,
                                                                    visible: watch('jobId' + row.resource_id)
                                                                },
                                                                {
                                                                    label: 'Job',
                                                                    size: 11,
                                                                    inputSize: 4,
                                                                    required: false,
                                                                    name: 'jobId' + row.resource_id,
                                                                },
                                                            ]} />
                                                        {resourceKeyData.length > 0 && <ModalButtonBuilder title='View Keys' className='btn-secondary offset-md-4' size='lg'
                                                            type='button'
                                                            body={
                                                                <Container>
                                                                    <Card>
                                                                        <CardBody>
                                                                            <TableBuilder
                                                                                data={resourceKeyData}
                                                                                processing={false}
                                                                                pagination={false}
                                                                                columns={[
                                                                                    {
                                                                                        name: 'ID',
                                                                                        selector: (row) => row.resource_key_id,
                                                                                        sortable: true,
                                                                                        center: true,
                                                                                        maxWidth: '15%'
                                                                                    },
                                                                                    {
                                                                                        name: 'Name',
                                                                                        selector: (row) => row.key,
                                                                                        sortable: true,
                                                                                        center: true,
                                                                                    }
                                                                                ]}
                                                                            />
                                                                        </CardBody>
                                                                    </Card>
                                                                </Container>
                                                            }
                                                        />}
                                                    </Form>
                                                }
                                            />,

                                    }
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Container>
            </Row>
        </Fragment>
    );
};
export default ServiceResources;